/* import __COLOCATED_TEMPLATE__ from './stripe-payment-element.hbs'; */
import { action } from '@ember/object';
import {
  buildStripePaymentElement,
  buildStripeSetupModeElement,
} from 'client-portal/utils/stripe-payment-methods';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';

export default class SiteBillingStripePaymentElement extends Component {
  @service stripe;
  @service localeManager;
  @service currentPractice;
  @service session;

  @tracked isPaymentElementLoaded = false;

  @action
  attachPaymentElement(_element) {
    this.elements = buildStripeSetupModeElement(this.stripe.stripe, {
      locale: this.localeManager.currentLocaleForStripe,
      currency: this.currentPractice.get('currency'),
      onBehalfOf: this.currentPractice.get('stripeConnectedAccountId'),
      featureStripeLinkPassthroughMode: this.currentPractice.get(
        'featureStripeLinkPassthroughMode'
      ),
    });

    let paymentElementOptions = {
      onReady: () => {
        this.isPaymentElementLoaded = true;
      },
      featureStripeLinkPassthroughMode: this.currentPractice.get(
        'featureStripeLinkPassthroughMode'
      ),
      disableLink: this.currentPractice.get('featureStripeAchPayments'),
    };

    if (this.currentPractice.get('featureStripeLinkPassthroughMode')) {
      let client = this.session.currentClientAccess?.client;
      if (client) {
        paymentElementOptions.email = client.email;
        paymentElementOptions.phone = client.phoneNumber;
      }
    }

    this.paymentElement = buildStripePaymentElement(this.elements, paymentElementOptions);

    this.paymentElement.mount('#payment-element');
  }

  @action
  async persistStripePaymentMethod() {
    let { model } = this.args;

    model.set('_isDirty', true);

    await model.validate();

    let { error } = await this.elements.submit();
    if (error || !model.name.trim()) {
      return;
    }

    this.args.addStripePaymentMethod(this.elements);
  }
}
